const loginModule = {
    login: "登录",
    phonePlaceholder: "请输入手机号",
    emailPlaceholder: "请输入邮箱",
    passwordPlaceholder: "请输入密码",
    register: "注册",
    forgetText: "忘记密码",
    ruleText1: "使用条款",
    ruleText2: "个人信息的收集和使用",
    ruleText3: "同意",
    rule: "使用条款",
    questionText: "登录遇到问题",
    questionSubText: "部分可用功能存在限制",
    otherLogin: "其它登录",
    otherLoginText: "其它登录方式",
    routeLoading: "正在跳转...",
    returnLogin: "退出登录",
    visitorsLogin: "访客登录",
    agentWarn: "[匿名登录]使用无痕模式或者清空浏览器缓存，会导致用户信息丢失。",
    emailPlaceholder: "请输入邮箱",
    accountExample: "ID(例：08012341234)",
    lineLogin: "LINE登录",
    lineLoginDesc: "在LINE上使用时，请点击“在LINE上登录”，然后按“允许”。",
    nohaveAccount: "没有账号吗？"
};

export default loginModule;